import { render, staticRenderFns } from "./CollectionsMarketsList.vue?vue&type=template&id=01e86167&scoped=true"
import script from "./CollectionsMarketsList.vue?vue&type=script&lang=js"
export * from "./CollectionsMarketsList.vue?vue&type=script&lang=js"
import style0 from "./CollectionsMarketsList.vue?vue&type=style&index=0&id=01e86167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e86167",
  null
  
)

export default component.exports